import React from 'react';
import { Navigate } from 'react-router-dom';
import { path } from '../Utils/ScreenPath';

const PublicRoute = ({ Component, ...rest }) => {
  const token = localStorage.getItem('token');

  return token !== null ? <Navigate to={path?.SectionWise} /> : <Component {...rest} />;
};

export default PublicRoute;
